import React, { Component, PropTypes } from 'react';

class PagesFindRes extends Component {
    render() {
        return (
            <div>
                Content of PagesFindRes
                <hr />
                {this.props.children}
            </div>
        );
    }
}

PagesFindRes.propTypes = {
    children: PropTypes.element
};

export default PagesFindRes;



// WEBPACK FOOTER //
// ./src/components/pages/pages/PagesFindRes.js